import { useState, useLayoutEffect } from "react";

/**
 * A hook that detects if the current viewport is mobile-sized using matchMedia
 * @param query - The media query to match (default: '(max-width: 767px)')
 * @returns True if the media query matches. It also returns a pending state which is true until the useLayoutEffect has run.
 */
const useIsMobileViewport = (query = "(max-width: 767px)") => {
    const [matches, setMatches] = useState(false);
    const [isPending, setIsPending] = useState(true);

    useLayoutEffect(() => {
        const mediaQuery = window.matchMedia(query);
        setMatches(mediaQuery.matches);
        setIsPending(false);

        mediaQuery.onchange = (event) => {
            setMatches(event.matches);
        };

        return () => {
            mediaQuery.onchange = null;
        };
    }, [query]);

    return { isMobileViewport: matches, isPending: isPending };
};

export default useIsMobileViewport;
